<template>
  <TirPmModal
    :is-visible="dialogType !== undefined"
    :title="title"
    :is-with-back="false"
    @close="confirm"
  >
    <template #content> {{ contentText }} </template>
    <template #footer>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.PrimaryState"
        @click="cancel"
      >
        <div style="padding: 0 0.5rem">{{ cancelButtonText }}</div>
      </TirPmButton>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.SecondaryState"
        @click="confirm"
      >
        <div style="padding: 0 0.688rem">{{ confirmButtonText }}</div>
      </TirPmButton>
    </template>
  </TirPmModal>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmModal,
} from 'tir-components';
import { TaskDialogEnum } from './enums';

const dialogType = ref<TaskDialogEnum>();

let callback: (confirm: boolean) => void | undefined = undefined;

/**Заголовок модального окна */
const title = computed(() => {
  switch (dialogType.value) {
    case TaskDialogEnum.ExitWithoutSaving:
      return 'Отменить создание?';
    case TaskDialogEnum.DataWillBeOverwritten:
      return 'Введенные данные будут изменены';
    case TaskDialogEnum.ImportedDataWillBeReset:
      return 'Импортированные данные будут сброшены';
    case TaskDialogEnum.CancelDescriptionChanges:
      return 'Отмена изменений';
  }
});

/**Текст контента */
const contentText = computed(() => {
  switch (dialogType.value) {
    case TaskDialogEnum.CancelDescriptionChanges:
      return 'Вы действительно хотите отменить все изменения, внесенны в описание?';
    default:
      return 'Если выйти сейчас, введенные данные не сохранятся';
  }
});

/**Текст кнопки подтверждения */
const confirmButtonText = computed(() => {
  switch (dialogType.value) {
    case TaskDialogEnum.ExitWithoutSaving:
      return 'Выйти';
    case TaskDialogEnum.CancelDescriptionChanges:
      return 'Остаться';
    case TaskDialogEnum.DataWillBeOverwritten:
    case TaskDialogEnum.ImportedDataWillBeReset:
      return 'Продолжить';
  }
});
/**Текст кнопки отмены */
const cancelButtonText = computed(() => {
  switch (dialogType.value) {
    case TaskDialogEnum.ExitWithoutSaving:
    case TaskDialogEnum.DataWillBeOverwritten:
    case TaskDialogEnum.ImportedDataWillBeReset:
      return 'Вернуться к редактированию';
    case TaskDialogEnum.CancelDescriptionChanges:
      return 'Отменить изменения';
  }
});

/**Открыть модальное окно */
const open = async (_dialogType: TaskDialogEnum) => {
  return new Promise<boolean>((resolve) => {
    callback = (confirm) => {
      resolve(confirm);
    };
    dialogType.value = _dialogType;
  });
};
/**Закрыть модальное окно */
const close = () => {
  dialogType.value = undefined;
  callback = undefined;
};

/**При выходе */
const cancel = () => {
  callback?.(false);
  close();
};

/**При отмене выхода */
const confirm = () => {
  callback?.(true);
  close();
};

defineExpose({
  open,
});
</script>

<style lang="scss" scoped></style>
